import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  storesList: [],
  store: null,
};

const storeSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    setStore: (state, action) => {
      state.store = action.payload;
    },
    setStoresList: (state, action) => {
      state.storesList = action.payload;
      state.store = null; // Optional: Reset selected store when list updates
    },
  },
});

export const { setStore, setStoresList } = storeSlice.actions;
export default storeSlice.reducer;
